import { render, staticRenderFns } from "./profile-page.vue?vue&type=template&id=66321993"
import script from "./profile-page.vue?vue&type=script&lang=js"
export * from "./profile-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66321993')) {
      api.createRecord('66321993', component.options)
    } else {
      api.reload('66321993', component.options)
    }
    module.hot.accept("./profile-page.vue?vue&type=template&id=66321993", function () {
      api.rerender('66321993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Profile/profile-page.vue"
export default component.exports